import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
// import Vuetify from 'vuetify/lib'
// Vue.use(Vuetify)
// Vue.config.productionTip = false

// const vuetify = new Vuetify({
//   theme: {
//     dark: false, // initial (we’ll override from localStorage/system below)
//     themes: {
//       light: {
//         primary: '#1976D2',
//       },
//       dark: {
//         primary: '#90CAF9',
//       },
//     },
//   },
// })

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App),
  // async created () {
  //   await this.$store.dispatch('ui/initTheme')
  //   this.$vuetify.theme.dark = this.$store.getters['ui/dark']
  //   this.$watch(() => this.$store.getters['ui/dark'], (val) => {
  //     this.$vuetify.theme.dark = val
  //   })
  // },
}).$mount('#app')
